import React from 'react'

import img from '../../assets/images/pages/investment/hero-bg.png'
import NewCollectionBannerTop from '../NewCollectionBanner/NewCollectionBannerTop'

export default function InvestmentMainBanner() {
  return (
    <section className='section' id='#investment-banner'>
      <NewCollectionBannerTop
        title={'Инвестиции в будущее'}
        lead={'Покупка квартиры как способ сохранить свои деньги'}
        img={img}
        id={0}
        buttonContent='Выбрать квартиру'
        classMod='investment'
        clickHandler={() => {}}
        link='/invest'
      />
    </section>
  )
}
